import { __assign } from "tslib";
import produce from 'immer';
import * as color from '../property/color';
import * as fill from '../property/fill';
import { SizeUtils, PointUtils } from '../math';
export function create(partial) {
    if (partial === void 0) { partial = {}; }
    return __assign({ fills: [fill.createColorFill(color.createFromRgba([1, 1, 1, 1]))], point: PointUtils.create(0, 0), size: SizeUtils.create(1, 1), pixelRatio: 1, designRatio: 1 }, partial);
}
export function mSetSize(mutable, newSize) {
    mutable.size = newSize;
    return mutable;
}
export var setSize = produce(mSetSize);
